import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import HospitalIndemnityModal from './HospitalIndemnityModal';

const HospitalIndemnityModalDemo = () => {
  const [showHospitalIndemnityModal, setShowHospitalIndemnityModal] =
    React.useState<boolean>(false);

  const handleShowHospitalIndemnityModal = () =>
    setShowHospitalIndemnityModal(true);
  const handleCloseHospitalIndemnityModal = () =>
    setShowHospitalIndemnityModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Hospital Indemnity Modal</h4>
        <Button onMouseDown={handleShowHospitalIndemnityModal}>
          Open Modal
        </Button>
        <HospitalIndemnityModal
          showHospitalIndemnityModal={showHospitalIndemnityModal}
          handleCloseHospitalIndemnityModal={handleCloseHospitalIndemnityModal}
        />
      </Container>
    </Container>
  );
};

export default HospitalIndemnityModalDemo;
